const bg = {
  "Home": "Начало",
  "Add": "Добави",
  "Edit": "Редакция",
  "Adding": "Добавяне на",
  "Editing": "Редактиране на",
  "Delete": "Изтрий",
  "Save": "Запази",
  "Cancel": "Откажи",
  "Close": "Затвори",
  "Open": "Отвори",
  'View': 'Преглед',
  'Remove': 'Премахни',
  'Sensor': 'Сензор',
  'Room': 'Стая',
  'TotalBuildingConsumption': 'Консумация на сградата',
  'EnergyDistribution': 'Разпределение на ел. енергия',
  'Common': 'Други показатели',
  'WeatherStation': 'Метеорологична станция',
  'VisitorsMonth': 'Посетители на месец',
  'VisitorsYear': 'Посетители на година',
  'Alarms': 'Аларми',
  'DayWithoutAccidents': 'Дни без инциденти',
  'InternalTemperature': 'Вътрешна темепература',
  'OutsideTemperature': 'Външна темепература',
  'WindSpeed': 'Скорост на вятъра',
  'Humidity': 'Влажност',
  'Еlectricity': 'Електричество',
  'Water': 'Вода',
  'Air': 'Въздух',
  'Gas': 'Газ',
  'Production': 'Производство',
  'Compressor': 'Компресори',
  'Lighting': 'Осветление',
  'Machines': 'Машини',
  'Administration': 'Администрация',
  'Animation': 'Анимация',
  'Animations': 'Анимации',
  'January': 'Януари',
  'February': 'Февруари',
  'March': 'Март',
  'April': 'Април',
  'May': 'Май',
  'June': 'Юни',
  'July': 'Юли',
  'August': 'Август',
  'September': 'Септември',
  'October': 'Октомври',
  'November': 'Ноември',
  'December': 'Декември',
  'Main Scene': 'Начало',
  'Main Hall': 'Производствен цех',
  'Assembly Line': 'Линия за асемблиране',
  'Innovation hub': 'Innovation Hub'
}


export default bg;